import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface BiomassBurningCellDisplayProps {
  value: any
}

export const BiomassBurningCellDisplay = ({ value }: BiomassBurningCellDisplayProps) => {
  const { t } = useTranslation('@cibo/landmanager/BiomassBurningEditor')

  return (
    <Stack>
      <Typography>{value?.result === 0 ? t('no') : t('yes')}</Typography>
      <Typography variant="body2" color="text.secondary">
        {t('percentValue', { count: value?.result })}
      </Typography>
    </Stack>
  )
}
